import { render, staticRenderFns } from "./listTingboxCtv.vue?vue&type=template&id=7232d492"
import script from "./listTingboxCtv.vue?vue&type=script&lang=js"
export * from "./listTingboxCtv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports